export class ChargeVerificationConfigLoadError extends Error {
  constructor(cause: unknown) {
    super('The charge verification setting could not be loaded', { cause });
    this.name = 'ChargeVerificationConfigLoadError';
  }
}
